import { motion, useReducedMotion } from 'framer-motion'
import { rise, VIEWPORT } from '../../utils/motion'

// The default entrance on the marketing site: a springy rise-and-settle that
// fires once as the element scrolls into view. `y` sets how far it travels.
export default function Reveal({ as = 'div', delay = 0, y = 32, className = '', children, ...props }) {
  const reduce = useReducedMotion()
  const MotionTag = motion[as] || motion.div
  const variants = reduce
    ? { hidden: { opacity: 0 }, show: { opacity: 1, transition: { duration: 0.3, delay } } }
    : rise(delay, y)
  return (
    <MotionTag
      variants={variants}
      initial="hidden"
      whileInView="show"
      viewport={VIEWPORT}
      className={className}
      {...props}
    >
      {children}
    </MotionTag>
  )
}

// A group whose direct children (Reveal / Pop / any motion child with
// hidden/show variants) enter one after another.
export function RevealGroup({ as = 'div', each = 0.07, delay = 0, className = '', children, ...props }) {
  const MotionTag = motion[as] || motion.div
  return (
    <MotionTag
      variants={{ hidden: {}, show: { transition: { staggerChildren: each, delayChildren: delay } } }}
      initial="hidden"
      whileInView="show"
      viewport={VIEWPORT}
      className={className}
      {...props}
    >
      {children}
    </MotionTag>
  )
}

// A child of RevealGroup: inherits the group's timing, no own viewport.
export function RevealItem({ as = 'div', y = 32, className = '', children, ...props }) {
  const reduce = useReducedMotion()
  const MotionTag = motion[as] || motion.div
  const variants = reduce
    ? { hidden: { opacity: 0 }, show: { opacity: 1, transition: { duration: 0.3 } } }
    : rise(0, y)
  return (
    <MotionTag variants={variants} className={className} {...props}>
      {children}
    </MotionTag>
  )
}
